import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EndpointService} from './endpoint.service';
import {GetChartResponse} from '../responses/GetChartResponse';
import {OrdersOnCategoriesResponse} from '../responses/OrdersOnCategoriesResponse';
import {GetCompanyEventsResponse} from '../responses/GetCompanyEventsResponse';
import {map, of, tap} from 'rxjs';
import {EventModel} from "../models/EventModel";

@Injectable({providedIn: 'root'})
export class DashboardService {
  constructor(private http: HttpClient) {
  }

  private userPendingCashback?: number;

  getCompanyEvents(subDomain: string) {
    return this.http.get<GetCompanyEventsResponse>(EndpointService.getActiveCompanyEvents(subDomain));
  }

  getCompanyEvent(subDomain: string, eventId: number) {
    return this.http.get<{responseObject: EventModel}>(EndpointService.getActiveCompanyEvent(subDomain, eventId));
  }

  getChartInfo() {
    return this.http.get<GetChartResponse>(EndpointService.getChartInfo);
  }

  ordersOnCategories(data: string) {
    return this.http.post<OrdersOnCategoriesResponse>(EndpointService.ordersOnCategories, `"${data}"`, {
      headers: {
        'Content-Type': 'application/json-patch+json',
        'accept': 'text/plain'
      }
    });
  }

  getPendingCashback() {
    if (this.userPendingCashback !== undefined && this.userPendingCashback !== null) {
      return of(this.userPendingCashback);
    }
    return this.http.get<{ responseObject: number }>(EndpointService.getCashbackPendingAmount).pipe(
      map(response => response.responseObject)
    ).pipe(tap({
      next: value => {
        this.userPendingCashback = value;
      },
      error: err => {
        //clean cache if we get a failure from upstream
        this.clearCache();
      }
    }));
  }

  clearCache() {
    this.userPendingCashback = null;
  }
}
